<template>
    <input
        v-once
        v-bind="$attrs"
        :time-id="`${id}`"
        @input="inputUpdate"
        @keydown.tab="hide"
        type="text"
        class="timepicker"
    />
</template>
<script>
import "bootstrap-timepicker";
import { DateTime } from "luxon";
import { debounce } from "lodash";
import uuidv4 from "uuid/v4";

export default {
    name: "VetTimePicker",
    props: {
        value: {
            type: [DateTime, Date, moment, String, Number],
            default: null
        },
        format: {
            type: String,
            validator: function (value) {
                // The value must match one of these strings
                return ["moment", "iso", "datetime"].includes(
                    value.toLowerCase()
                );
            },
            default: "DateTime"
        },
        step: {
            type: Number,
            default: 5
        },
        isUpdateTimeDebounce: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            id: uuidv4(),
            myTime: null,
            skipUpdate: false
        };
    },
    computed: {
        toStringTime(datetime) {
            return datetime.toFormat("h:mm a");
        }
    },
    watch: {
        value: {
            handler(value, oldValue) {
                if (
                    value &&
                    oldValue &&
                    this._toDateTime(value) === this._toDateTime(oldValue)
                ) {
                    return;
                }
                this.myTime = this._toDateTime(value);
                this.skipUpdate = true;

                $(`[time-id=${this.id}]`).timepicker(
                    "setTime",
                    this.myTime ? this.myTime.toFormat("h:mm a") : null
                );
            },
            immediate: true
        }
    },
    created() {},
    mounted() {
        if (this.isUpdateTimeDebounce) {
            // From date-time-picker, the isUpdateTimeDebounce passed using v-bind
            // Create a debounced version of updateTime
            this.debouncedUpdateTime = debounce(
                this.updateTime.bind(this),
                300
            );
        } else {
            this.debouncedUpdateTime = this.updateTime.bind(this);
        }

        $(`[time-id=${this.id}]`)
            .timepicker({
                minuteStep: this.step,
                icons: {
                    up: "fas fa-chevron-up",
                    down: "fas fa-chevron-down"
                }
            })
            .off("changeTime.timepicker") // Ensure no duplicate event listeners
            .on("changeTime.timepicker", event => {
                this.debouncedUpdateTime(event);
            })
            .on("show.timepicker", event => {
                this.$emit("show", event);
            })
            .on("hide.timepicker", event => {
                this.$emit("hide", event);
            });

        // Set the initial time after event listeners are bound

        $(`[time-id=${this.id}]`).timepicker(
            "setTime",
            this.myTime ? this.myTime.toFormat("h:mm a") : null
        );
    },
    methods: {
        updateTime(event) {
            let value = DateTime.fromFormat(
                event?.time?.value || event,
                "h:m a",
                { zone: this._timeZone }
            );
            if (this.skipUpdate || !value.isValid) {
                this.skipUpdate = false;
                return;
            }
            this.$emit(
                "input",
                value ? this._fromDateTime(value, this.format) : null
            );
        },
        inputUpdate: debounce(function (event) {
            if (!event.target.value) {
                this.$emit("input", null);
            } else {
                this.updateTime(event.target.value);
            }
        }, 300),
        show() {
            $(`[time-id=${this.id}]`).timepicker("showWidget");
        },
        hide() {
            $(`[time-id=${this.id}]`).timepicker("hideWidget");
        }
    }
};
</script>
<style lang="scss">
@import "bootstrap-timepicker/css/timepicker.less";
.bootstrap-timepicker-widget table td input {
    width: 25px;
    margin: 0;
    text-align: center;
    border: none;
}
.bootstrap-timepicker-widget .modal-content {
    padding: 4px;
}
</style>
